

import React from 'react';

const BusinessDetailsStep = ({ form, handleChange }) => {
  return (
    <div className="agreements-step-content">
      <h2>Business Details</h2>
      <p>Please enter the business details that will be used for TrackBiz onboarding.</p>

      <div className="agreements-form-grid">
        <label>
          <span className="field-label">
            Business Display Name <span className="required-star">*</span>
          </span>
          <input
            name="businessName"
            value={form.businessName}
            onChange={handleChange}
            placeholder="Example: Store 1688"
            required
          />
        </label>

        <label>
          <span className="field-label">
            Legal Business Name <span className="required-star">*</span>
          </span>
          <input
            name="legalBusinessName"
            value={form.legalBusinessName}
            onChange={handleChange}
            placeholder="Example: K&L Solutions LLC"
            required
          />
        </label>

        <label>
          <span className="field-label">
            Owner / Authorized Signer Name <span className="required-star">*</span>
          </span>
          <input
            name="ownerName"
            value={form.ownerName}
            onChange={handleChange}
            placeholder="Example: Po Zhang"
            required
          />
        </label>

        <label>
          <span className="field-label">
            Title <span className="required-star">*</span>
          </span>
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Example: Owner"
            required
          />
        </label>

        <label>
          <span className="field-label">
            Email <span className="required-star">*</span>
          </span>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="owner@example.com"
            required
          />
        </label>

        <label>
          <span className="field-label">
            Phone <span className="required-star">*</span>
          </span>
          <input
            name="phone"
            type="tel"
            value={form.phone}
            onChange={handleChange}
            placeholder="(555) 555-5555"
            required
          />
        </label>

        <label className="agreements-full-width">
          <span className="field-label">
            Business Address <span className="required-star">*</span>
          </span>
          <input
            name="businessAddress"
            value={form.businessAddress}
            onChange={handleChange}
            placeholder="Street address"
            required
          />
        </label>

        <label>
          <span className="field-label">
            City <span className="required-star">*</span>
          </span>
          <input
            name="city"
            value={form.city}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          <span className="field-label">
            State <span className="required-star">*</span>
          </span>
          <input
            name="state"
            value={form.state}
            onChange={handleChange}
            placeholder="TX"
            required
          />
        </label>

        <label>
          <span className="field-label">
            ZIP Code <span className="required-star">*</span>
          </span>
          <input
            name="zipCode"
            value={form.zipCode}
            onChange={handleChange}
            required
          />
        </label>
      </div>
    </div>
  );
};

export default BusinessDetailsStep;